import {ThermalBackpackBrandEnum} from '@/models/digital-document-queue-sender-transfer-protocol-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function thermalBackpackBrandNameFilter(type: ThermalBackpackBrandEnum) {
  switch(type) {
    case ThermalBackpackBrandEnum.UberEats: return 'UberEats';
    case ThermalBackpackBrandEnum.BoltFood: return 'BoltFood';
    case ThermalBackpackBrandEnum.Other: return i18n.t(LF.Unbranded) as string;

  }
}
